import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { ContactService } from '@profile/infra';
import { CreateContactMessageBody } from '@core-http';

export class SendFeedbackCommandHandler {
  private readonly contactService: ContactService = inject(ContactService);

  send(message: string): Observable<void> {
    const requestBody: CreateContactMessageBody = { message };

    return this.contactService.sendMessage(requestBody);
  }
}
